import type { EntitySurfaceOperation } from '@workbuddy/services/entities';

/** Path prefix for generic entity pages: `/entity/:slug/:operation`. */
export const ENTITY_RECORD_PATH = 'entity';

/** Where a denied record link lands: `/entity/no-access`. A message only, so it needs no rights of its own. */
export const ENTITY_NO_ACCESS_PATH = `${ENTITY_RECORD_PATH}/no-access`;

/** Builds the generic list URL for an entity, or null when no registered slug was supplied. */
export function entityListUrl(slug: string | undefined): string | null {

  return slug ? `/${ENTITY_RECORD_PATH}/${slug}` : null;
}

/**
 * Builds the generic full-page URL for a record, or null when no registered slug was supplied.
 *
 * Null is the "not routable" answer for an unregistered entity and the caller hides its action.
 *
 * The id is a matrix param rather than a path segment so the route shape matches the inspector's,
 * where create has no id at all.
 */
export function entityRecordUrl(slug: string | undefined, operation: EntitySurfaceOperation, id?: string): string | null {

  if (!slug) return null;

  const base = `/${ENTITY_RECORD_PATH}/${slug}/${operation}`;
  return id ? `${base};id=${encodeURIComponent(id)}` : base;
}
